import React, {
  useRef,
  useContext,
  useState,
  useCallback,
  useEffect,
  useMemo,
} from 'react';
import FiltersContent from './Filters';
import Fixed from './Fixed';
import useScrollPosition from '../../../hooks/useScrollPosition';
import useApi from '../../../hooks/useApi';
import { Context } from '../../../context/AppContext';
import './styles.css';

const Filters = ({ ...props }) => {
  const {
    media: { tablet, desktop, mobile },
  } = useContext(Context);
  const [fixed, setFixed] = useState();
  const [filtersCount, setFiltersCount] = useState({});
  const { fetch, data } = useApi('ListFilters');
  const ref = useRef();
  const { filters, params, pathname } = props || {};
  const { filters: dataFilters } = data || {};
  const { serviceCategory } = filters || {};
  const serviceCategories = {};

  useEffect(() => {
    if (filters) {
      const getFiltersCount = Object.keys(filters || {}).reduce((agg, key) => {
        const sumCount = (filters[key] || []).reduce((filterAgg, item) => {
          const { count, value } = item || {};
          return { ...filterAgg, [value]: count };
        }, {});
        return {
          ...agg,
          ...sumCount,
        };
      }, {});
      setFiltersCount(getFiltersCount);
    }
  }, [filters]);

  useEffect(() => {
    if (dataFilters) {
      const getFiltersCount = Object.keys(dataFilters || {}).reduce(
        (agg, key) => {
          const sumCount = (dataFilters[key] || []).reduce(
            (filterAgg, item) => {
              const { count, value } = item || {};
              return { ...filterAgg, [value]: count };
            },
            {}
          );
          return {
            ...agg,
            ...sumCount,
          };
        },
        {}
      );
      setFiltersCount(getFiltersCount);
    }
  }, [dataFilters]);

  const defaultServiceCategory = useMemo(() => {
    if (!serviceCategories[pathname]) {
      serviceCategories[pathname] = [...(serviceCategory || [])].map(
        service => ({
          ...service,
          count: 0,
          checked: false,
        })
      );
      return serviceCategory || [];
    }
    return serviceCategories[pathname] || [];
  }, [pathname, serviceCategory]);

  const callback = useCallback(({ top }) => {
    const topPosition = -87;
    if (top <= topPosition) {
      setFixed(true);
    } else {
      setFixed(false);
    }
  }, []);

  const updateFiltersCount = value => {
    fetch({
      params: {
        ...params,
        filter: value,
      },
    });
  };

  useScrollPosition(ref, callback);

  return (
    <div className="Listview__Filters__root" ref={ref}>
      {(desktop || tablet) && (
        <Fixed show={fixed}>
          {fixed && (
            <FiltersContent
              {...props}
              SERVICE_CATEGORY={defaultServiceCategory}
              fixed={fixed}
              updateFiltersCount={updateFiltersCount}
              filtersCount={filtersCount}
            />
          )}
        </Fixed>
      )}
      <FiltersContent
        {...props}
        SERVICE_CATEGORY={defaultServiceCategory}
        filtersCount={filtersCount}
        updateFiltersCount={updateFiltersCount}
        showFiltersMobile={mobile}
      />
    </div>
  );
};

export default Filters;
